import { motion } from "framer-motion";
import { Twitter, Linkedin, Github, Mail } from "lucide-react";
import { TID, LOGO_URL, WORDMARK_URL } from "../../lib/testIds";

const links = [
    { label: "Product", target: "what-is" },
    { label: "Vision", target: "vision" },
    { label: "Waitlist", target: "waitlist" },
    { label: "Contact", target: "waitlist" },
];

const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const Footer = () => (
    <footer
        data-testid={TID.footer}
        className="relative pt-20 pb-10 px-6 overflow-hidden"
    >
        {/* Top border beam */}
        <div className="absolute top-0 left-0 right-0 h-px beam" />

        <div
            aria-hidden
            className="absolute -top-40 left-1/2 -translate-x-1/2 w-[600px] h-[200px] rounded-full"
            style={{
                background:
                    "radial-gradient(closest-side, rgba(139,92,246,0.10), transparent)",
                filter: "blur(20px)",
            }}
        />

        <div className="max-w-7xl mx-auto relative z-10">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                <div className="md:col-span-5">
                    <div className="flex items-center gap-3">
                        <img
                            src={LOGO_URL}
                            alt="Lambda Quest"
                            className="w-11 h-11 object-contain"
                            style={{
                                filter:
                                    "drop-shadow(0 0 10px rgba(139,92,246,0.35))",
                            }}
                        />
                        <div className="relative overflow-hidden h-5 flex items-center">
                            <img
                                src={WORDMARK_URL}
                                alt="LAMBDA QUEST"
                                className="h-[110px] w-auto max-w-none"
                            />
                        </div>
                    </div>
                    <p className="mt-5 max-w-sm text-[#6B7280] dark:text-white/55 text-sm leading-relaxed">
                        Building world-class software infrastructure for modern
                        education and training.
                    </p>
                </div>

                <div className="md:col-span-4">
                    <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-[#9CA3AF] dark:text-white/40">
                        Navigate
                    </p>
                    <ul className="mt-5 grid grid-cols-2 gap-3">
                        {links.map((l) => (
                            <li key={l.label}>
                                <button
                                    onClick={() => scrollTo(l.target)}
                                    data-testid={`${TID.footerLink}-${l.label.toLowerCase()}`}
                                    className="text-[#6B7280] hover:text-[#111827] dark:text-white/70 dark:hover:text-white transition-colors text-sm"
                                >
                                    {l.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="md:col-span-3">
                    <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-[#9CA3AF] dark:text-white/40">
                        Connect
                    </p>
                    <div className="mt-5 flex items-center gap-3">
                        {[Twitter, Linkedin, Github, Mail].map((Ic, i) => (
                            <motion.a
                                key={i}
                                href="#"
                                whileHover={{ y: -3 }}
                                className="flex items-center justify-center w-10 h-10 rounded-full border border-black/[0.08] bg-[#F9FAFB] hover:border-violet-300 hover:bg-violet-50 dark:border-white/10 dark:bg-white/[0.02] dark:hover:border-brand-purple/40 dark:hover:bg-brand-purple/10 transition-colors text-[#6B7280] hover:text-violet-600 dark:text-white/70 dark:hover:text-white"
                            >
                                <Ic size={16} />
                            </motion.a>
                        ))}
                    </div>
                </div>
            </div>

            <div className="mt-14 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-black/[0.06] dark:border-white/[0.06] pt-6">
                <p className="font-mono text-[11px] tracking-wider text-[#9CA3AF] dark:text-white/35">
                    &copy; {new Date().getFullYear()} Lambda Quest. All rights
                    reserved.
                </p>
                <p className="font-mono text-[11px] tracking-wider text-[#9CA3AF] dark:text-white/35">
                    Designed in the dark. Built for the light.
                </p>
            </div>
        </div>
    </footer>
);

export default Footer;
